import moment from 'moment';

export function fromNow(given: string, invalidDate: string = 'never') {
  const str = moment(given).fromNow();
  if (str === 'Invalid date') {
    return invalidDate;
  }

  return str;
}

export function formatDate(given: string, format: string = 'MMM DD, YYYY, h:mm:ss a') {
  if (!given) {
    return '-';
  }

  return moment(given).format(format);
}
